import { AxiosResponse } from "axios";
import { SchoolPayload } from "models";
import { Client } from "./config";

export function FetchSchool(school_id: string):Promise<AxiosResponse<SchoolPayload>> {
  return Client.get<SchoolPayload>(`/data/class_dropdown?schoolID=${school_id}`);
}
